/* unplugin-vue-components disabled */import { render } from "./FilterBox.vue?vue&type=template&id=84823c80&scoped=true&ts=true"
import script from "./FilterBox.vue?vue&type=script&lang=ts"
export * from "./FilterBox.vue?vue&type=script&lang=ts"

import "./FilterBox.vue?vue&type=style&index=0&id=84823c80&lang=scss&scoped=true"
import "./FilterBox.vue?vue&type=style&index=1&id=84823c80&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84823c80"]])

export default __exports__